import React, { Component } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, Fade, MobileStepper, Typography } from '@mui/material';
import { ArrowRight, KeyboardArrowLeft } from '@mui/icons-material';
import { t } from 'i18next';

class MobIntroMyStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      activeColor: 'transparent', //linear-gradient(to right, #e8d3fb 35%, #c690f4 99%)',
      stepNumber: 2,
      steps: [
        <Fade in={true} timeout={450}>
          <Box sx={{ display: 'flex', textAlign: 'center', flexDirection: 'column' }}>
            <img src="/img/intro/advices.svg" alt='Advices' style={{width: "100%", maxHeight: "50vh"}} />
            <Typography sx={{ mt: 5, mb: 2, textTransform: 'uppercase' }} variant='h4' className='big'>{t("onboarding_stats1_title")}</Typography>
            <Box><Typography variant='body1' component={'h5'} sx={{ fontWeight: 300 }}>{t("onboarding_stats1_text")}</Typography></Box>
          </Box>
        </Fade>,
        <Fade in={true} timeout={450}>
          <Box sx={{ display: 'flex', textAlign: 'center', flexDirection: 'column' }}>
            <img src="/img/intro/intro-mypos.svg" alt='Positions' style={{width: "100%", maxHeight: "50vh"}} />
            <Typography sx={{ mt: 5, mb: 2, textTransform: 'uppercase' }} variant='h4' className='big'>{t("onboarding_stats2_title")}</Typography>
            <Box><Typography variant='body1' component={'h5'} sx={{ fontWeight: 300 }}>{t("onboarding_stats2_text")}</Typography></Box>
          </Box>
        </Fade>,
      ],
    }
  }

  handleNext() {
    this.setState((prevState, props) => ({
      activeStep: prevState.activeStep + 1,
      activeStatus: false
    }));
  }

  handleBack() {
    this.setState((prevState, props) => ({
      activeStep: prevState.activeStep - 1
    }));
  }

  handleEnd(){
    this.props.introClose()
    localStorage.setItem("ONB_MYSTATS", 1)
  }

  render() {
    const { activeStep, steps, stepNumber, activeColor } = this.state;
    const props = this.props;
    return (
      <div>
        <Dialog open={props.open} onClose={props.introClose} fullScreen sx={{ borderColor: 'transparent!important' }}>
          <DialogContent sx={{ background: activeColor }}>
            <Box sx={{ mb: 7 }}>
              {steps[activeStep]}
            </Box>
          </DialogContent>
          <DialogActions>
            <MobileStepper
              variant="dots"
              steps={stepNumber}
              position="static"
              activeStep={activeStep}
              sx={{ flexGrow: 1, background: 'transparent', borderColor: 'transparent!important' }}
              nextButton={
                <div>
                  {activeStep === stepNumber - 1 ?
                    <Button disableElevation variant='contained' size="large" onClick={() => this.handleEnd()}>
                      Get started
                    </Button>
                    :
                    <Button disableElevation variant='outlined' size="large" onClick={() => this.handleNext()} endIcon={<ArrowRight />}>
                      Continue
                    </Button>}
                </div>
              }
              backButton={
                <Button disableElevation size="large" onClick={() => this.handleBack()} disabled={activeStep === 0} startIcon={<KeyboardArrowLeft />}>
                  Back
                </Button>
              }
            />
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default MobIntroMyStats;